import React, { useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
import Config from './Config';
import { apiClient } from './store/store';
import {
	Modal,
} from 'antd';

let config = new Config();

// Perpanjang access token diam-diam selama masih ada aktivitas (mousemove/
// keydown), supaya sesi benar-benar sliding - bukan cuma cookie browser yang
// diperpanjang tanpa token JWT-nya ikut valid (access token sekarang berumur
// pendek di backend, lihat samsat/settings.py SIMPLE_JWT). Di-throttle di
// scope module (bukan per-instance) karena tiap route yang aktif me-mount
// listener mousemove/keydown-nya sendiri.
const TOKEN_REFRESH_INTERVAL_MS = 5 * 60 * 1000; // 5 menit
let lastTokenRefreshAttempt = 0;
let tokenRefreshInFlight = false;

const refreshAccessTokenSilently = () => {
	const now = Date.now();
	if (tokenRefreshInFlight || now - lastTokenRefreshAttempt < TOKEN_REFRESH_INTERVAL_MS) return;
	const refreshToken = Cookies.get(config.get_cookie_name() + "_refresh");
	if (!refreshToken) return;

	lastTokenRefreshAttempt = now;
	tokenRefreshInFlight = true;
	apiClient.post('api/token/refresh/', { refresh: refreshToken })
		.then((res) => {
			const newAccess = res.data && res.data.access;
			if (newAccess) {
				const expireTime = new Date(new Date().getTime() + 30 * 60 * 1000);
				Cookies.set(config.get_cookie_name(), 'Bearer ' + newAccess, { expires: expireTime });
			}
		})
		.catch(() => {
			// Diamkan - kalau refresh token juga sudah invalid/expired, request
			// API berikutnya akan 401 dan ditangani interceptor di store.js seperti biasa.
		})
		.finally(() => {
			tokenRefreshInFlight = false;
		});
};

export const LayananRoute = ({ component: Component, isAkses, ...rest }) => {
    const [counter, setCounter] = useState(3);
    const [isForbidden, setIsForbidden] = useState(false);
    const [isModalForbidden, setIsModalForbidden] = useState(false);

    // useEffect(() => {
    //     // Update the document title using the browser API
    //     if (isAkses == false) {
    //         setIsModalForbidden(true);
    //         doCounter();
    //     };
    //     console.log('cek update cookies here');
    // });
    // const cookies = new Cookies();

    const updateCookie = () => {
        // cookies.set("session", "active", { path: "/", maxAge: 1800 }); // 30 menit
        // console.log("Cookie diperbarui karena ada aktivitas pengguna.");
        // console.log(Cookies.get(config.get_cookie_name() + "_username"));
        const expireTime = new Date(new Date().getTime() + 30 * 60 * 1000);
        if (Cookies.get(config.get_cookie_name() + "_upt") != undefined && Cookies.get(config.get_cookie_name() + "_isNotice")) {
            Cookies.set(config.get_cookie_name() + "_isNotice", Cookies.get(config.get_cookie_name() + "_isNotice"), { expires: expireTime});
		    Cookies.set(config.get_cookie_name() + "_upt", Cookies.get(config.get_cookie_name() + "_upt"), { expires: expireTime});
        };
        
        Cookies.set(config.get_cookie_name(), Cookies.get(config.get_cookie_name()), { expires: expireTime});
		Cookies.set(config.get_cookie_name() + "_username", Cookies.get(config.get_cookie_name() + "_username"), { expires: expireTime});
		Cookies.set(config.get_cookie_name() + "_expired", Cookies.get(config.get_cookie_name() + "_expired"), { expires: expireTime});

        refreshAccessTokenSilently();
    };

    

    useEffect(() => {
        window.addEventListener("mousemove", updateCookie);
        window.addEventListener("keydown", updateCookie);
        


        return () => {
            window.removeEventListener("mousemove", updateCookie);
            window.removeEventListener("keydown", updateCookie);
        };
    }, []);

    function doCounter(){
        setTimeout(() => {
            if (counter > 0) {
                let temp = counter;
                temp -= 1;
                setCounter(temp);
                doCounter();
            } else {
                setIsForbidden(true)
            }
        }, 1000);
    }

    

    return (
        <Route {...rest} render={props => (
            isAkses
                ? <Component {...props} />
                :
                isForbidden
                    ?
                    <Redirect to={{ pathname: "/admin/forbidden", state: { from: props.location } }} />
                    :
                    <Modal
                        title="Akses Terbatas"
                        visible={isModalForbidden}
                        footer={[]}
                        closable={false}
                        width={"50%"}
                    >
                        <div
                            style={{
                                textAlign: "center",
                                fontSize: 24
                            }}
                        >
                            Akses Terbatas, Halaman ini akan ditutup dalam
                            <br />
                            <div style={{ color: "red" }}>
                                {counter}
                            </div>
                        </div>
                    </Modal>
        )} />
    )
};







// import React from 'react';
// import { Route, Redirect } from 'react-router-dom';
// import Cookies from 'js-cookie';
// import Config from './Config';

// let config = new Config();

// export const LayananRoute = ({ component: Component, isAkses, ...rest }) => (
//     <Route {...rest} render={props => (
//         isAkses
//             ? <Component {...props} />
//             : <Redirect to={{ pathname: "/admin/forbidden", state: { from: props.location } }} />
//     )} />
// );